module.exports = __webpack_public_path__ + "fonts/Cabin-Regular_dot.otf";